import React, { useState, useEffect } from "react";
import { useAuth0 } from "../../auth0/react-auth0-wrapper";
import Layout from "../../components/layout/Layout";
import Container from "../../components/container/Container";
import Loading from "../../components/loading/Loading";
import Button from "../../components/button/Button";
import ISODateStringSeconds from "../../functions/ISODateStringSeconds";
import ISODateString from "../../functions/ISODateString";
import UserRoleContext from "../../context/userrolecontext";
import LanguageContext from "../../context/languagecontext";
import GoogleMaps from "../../components/googlemaps/GoogleMaps";
import Styles from "./Machines.module.scss";

const apiUri = process.env.REACT_APP_API_URI;
const apiUpdateSpeed = process.env.REACT_APP_API_UPDATE_SPEED;

const Machines = () => {
  const [actualTime, setActualTime] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const { getTokenSilently } = useAuth0();
  const userRole = React.useContext(UserRoleContext);
  const { language } = React.useContext(LanguageContext);



















  useEffect(() => {
    const getSeconds = new Date().getSeconds();
    const getTimeout = getSeconds >= 30 ? (90 - getSeconds) * 1000 : (30 - getSeconds) * 1000;
    let repeatFetch = false;
    let runTimeOut = false;
    let runInterVal = false;
    let repeatErrorFetch = false;
    let runErrorInterval = false;
    let isCanceled = false;
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        const token = await getTokenSilently();

        const response = await fetch(`${apiUri}/machines`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          signal: controller.signal
        });
        if (isCanceled) {
          return;
        }
        if (!response.ok) {
          if (response.status === 403 || response.status === 423 || response.status === 401) {
            repeatErrorFetch = true;
          }
          throw Error(`${response.status}`);
        }
        runErrorInterval && clearInterval(runErrorInterval);
        const data = await response.json();
        if (!isCanceled) {
          setData(data);
          setError(null);
          setActualTime(ISODateStringSeconds(new Date()));
          repeatFetch = true;
          repeatErrorFetch = false;
          runErrorInterval && clearInterval(runErrorInterval);
        }
      } catch (err) {
        if (!isCanceled) {
          setError(err);
          // runTimeOut && clearTimeout(runTimeOut);
          // runInterVal && clearInterval(runInterVal);
          return;
        }
      }
    };
    fetchData();

    runErrorInterval = setInterval(() => {
      repeatErrorFetch && fetchData();
    }, 10000);
    
    runTimeOut = setTimeout(() => {
      fetchData();
      runInterVal = setInterval(() => {
        repeatFetch && fetchData();
      }, apiUpdateSpeed);
    }, getTimeout);


    return () => {
      isCanceled = true;
      controller.abort();
      runErrorInterval && clearInterval(runErrorInterval);
      runTimeOut && clearTimeout(runTimeOut);
      runInterVal && clearInterval(runInterVal);
    };
  }, [getTokenSilently]);





























  const renderContent = data ? (
    <>
      <div className={Styles.header}>
        <h1 className={Styles.title}>
          {language === "fr"
            ? "Aperçu des machines"
            : language === "it"
            ? "Lista macchine"
            : "Maschinen-Übersicht"}
        </h1>
        {actualTime && <p className={Styles.time}>{actualTime}</p>}
      </div>
      <div className={Styles.tableContainer}>
        <table>
          <thead>
            <tr>
              <th>
                {language === "fr"
                  ? "Désignation"
                  : language === "it"
                  ? "Designazione"
                  : "Bezeichnung"}
              </th>
              <th className={Styles.hideOnMobile}>
                {language === "fr"
                  ? "Groupe"
                  : language === "it"
                  ? "Gruppo"
                  : "Gruppe"}
              </th>
              <th className={Styles.centerText}>
                {language === "fr"
                  ? "Opération"
                  : language === "it"
                  ? "Operazione"
                  : "Betrieb"}
              </th>
              <th>
                {language === "fr"
                  ? "Site mis à jour"
                  : language === "it"
                  ? "Sito aggiornato"
                  : "Standort aktualisiert"}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((data, index) => (
              <tr key={index}>
                <td>
                  <Button
                    text={data.MachineName}
                    link={`/machine/${data.MachineName}`}
                    locationState={data.GroupNameShort}
                  />
                </td>
                <td className={Styles.hideOnMobile}>{data.GroupNameShort}</td>
                <td className={Styles.centerText}>
                  <span
                    className={
                      data.StringValue === "1"
                        ? Styles.mainSwitchOn
                        : Styles.mainSwitchOff
                    }
                  />
                </td>
                <td>{ISODateString(new Date(data.ServerRequestTimeStamp))}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  ) : (
    <Loading />
  );

  const renderAdmins = userRole && userRole.admins && userRole.admins.length >= 1 && (
    <div className={Styles.adminEmailContainer}>
      {userRole.admins.map(admin => 
        <a className={Styles.adminEmail} key={admin.email} href={`mailto:${admin.email}`}>{admin.email}</a>
      )}
    </div>
  )

  return (
    <Layout>
      <Container growHeight={!data ? true : error ? true : false}>
        {!error ? (
          renderContent
        ) : error.message === "403" ? (
          <Loading
            error={`${
              language === "fr"
                ? "Bienvenue sur vib connect"
                : language === "it"
                ? "Benvenuti a vib connect"
                : "Willkommen bei vib connect"
            }`}
            message={`${
              language === "fr"
                ? "Veuillez vérifier votre boîte de réception et suivre les instructions pour vérifier votre mail afin d`accéder à vib connect."
                : language === "it"
                ? "Controlla la tua casella postale e segui le istruzioni per verificare il tuo indirizzo e-mail per l’accesso a vib connect."
                : "Bitte überprüfen Sie Ihren Posteingang und folgen Sie den Anweisungen, um Ihre E-Mail-Adresse für den Zugang zu vib connect zu verifizieren."
            }`}
          />
        ) : error.message === "423" ? (
          <Loading
            error={`${
              language === "fr"
                ? "Compte en cours…"
                : language === "it"
                ? "Conto in corso…"
                : "Account in Bearbeitung…"
            }`}
            message={`${
              language === "fr"
                ? "Votre accès n’a pas encore été autorisé. Nous prenons la sécurité des données très au sérieux et nous activerons votre compte dès que possible."
                : language === "it"
                ? "Il vostro accesso non è stato ancora autorizzato. La sicurezza dei dati è molto importante per noi e attiveremo il vostro account il prima possibile."
                : "Ihr Zugang wurde noch nicht autorisiert. Wir nehmen die Sicherheit von Daten besonders ernst und werden ihren Account sobald wie möglich freischalten."
            }`}
          />
        ) : error.message === "401" ? (
          <>
          <Loading
            error={`${
              language === "fr"
                ? "Aucune machine sont attribuez"
                : language === "it"
                ? "Nessune macchine assegnale"
                : "Keine Maschinen zugewiesen"
            }`}
            message={`${
              language === "fr"
                ? "Aucune machine n’est actuellement affectée à votre compte. Veuillez contacter votre administrateur."
                : language === "it"
                ? "Al momento non ci sono macchine al vostro conto. Vi pregiamo di contattare il vostro amministratore."
                : "Ihrem Account sind zurzeit keine Maschinen zugewiesen. Bitte wenden sie sich an Ihren Administrator."
            }`}
          />
          {renderAdmins}
          </>
        ) : (
          <Loading
            error={`${
              language === "fr"
                ? "Erreur :"
                : language === "it"
                ? "Errore:"
                : "Fehler:"
            } ${error.message}`}
            message={`${
              language === "fr"
                ? "Veuillez réessayer plus tard."
                : language === "it"
                ? "Si prega di riprovare più tardi."
                : "Bitte versuchen Sie es später noch einmal."
            }`}
          />
        )}
      </Container>
      {data && !error && (
        <GoogleMaps data={data} language={userRole.language} />
      )}
    </Layout>
  );
};

export default Machines;
